module.exports = __webpack_public_path__ + "static/media/longU2ShortOOPairs.5f6871b4.mp3";